import { api } from 'services';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getPickUpPointList({ limit, cursor, q, status, warehouse_id } = {}) {
    const params = { limit, cursor, q, status, warehouse_id };
    return api.get('/pickup_points', {
      params: omitBy(params, isNil),
    });
  },

  createPickUpPoint(payload) {
    return api.post('/pickup_points', payload);
  },

  getPickUpPointDetails(id) {
    return api.get(`/pickup_points/${id}`);
  },

  updatePickUpPoint(payload, id) {
    return api.put(`/pickup_points/${id}`, payload);
  },

  reactivatePickUpPoint(id) {
    return api.put(`/pickup_points/${id}/reactivate`);
  },

  deactivatePickUpPoint(id) {
    return api.delete(`/pickup_points/${id}`);
  },

  deletePickUpPoint(id) {
    return api.delete(`/pickup_points/${id}/delete`);
  },
};
